function applyPromocode(items, sum) {
    const $goods = $('.dialog_cart .view');

    $goods.each(function (index) {
        const item = items[index];
        const $promoPrice = $(this).find('.js-promo-price');

        if ($promoPrice.length < 1) {
            $(this).find('.js-price').before(`<span class="price_old js-promo-price">${item.old_price}</div>`);
            $(this).find('.js-price').text(item.new_price);
        }
    });

    $('.basket_total2,.js-cart-total-sum').text(sum);
}

function updatePromocodeMode() {
    $('.js-promo-code').change();
}

$(document).on('keyup change', '.js-promo-code', function (ev) {
    const code = $(this).val();

    if (!code) {
        return;
    }

    $.post(
        '/basket/promocode/',
        {code},
        function (response) {
            if (!response) {
                return;
            }

            if (response.status === 'success') {
                applyPromocode(response.items, response.totalSum);

                $('#bask_title1, .bask_title1').html(response.basket.products);
                $('#bask_title2').html(response.basket.summa);
            }
        },
        'json'
    );
});

$('.js-promo-code').change();

export {updatePromocodeMode};
